import Alerts from '../../utils/rbialerts'

const state = new Alerts()
const getters = {}
const mutations = {
  add (state, payload) {
    let { category, msg } = payload
    state.add(category, msg)
  },
  remove (state, category) {
    // console.log('alerts/remove state', state)
    state.remove(category)
  },
  clear (state) {
    state.clear()
  }
}
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
